// Constants.
import {
  GET_HOME_PAGE,
  GET_ALL_PAGE_CONTENTS
} from '../actions/pageContentActions';

const initialState = {
  homePage: [],
  allPagesContents: []
};

export const pageContents = (state = initialState, action) => {
  switch (action.type) {
    case GET_HOME_PAGE:
      return {
        ...state,
        homePage: action.homePagePayload
      }
    case GET_ALL_PAGE_CONTENTS:
      return {
        ...state,
        allPagesContents: action.allPageContentsPayload
      }
    default:
      return state
  }
}
